var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_6040)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_6040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.726961 9.83872L6.1139 4.45178L15.3495 7.22247L10.8511 13.5202L0.726961 9.83872Z",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11L9 5.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5L8 12",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7L13 10",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10V8",
    stroke: "#7C7C7C",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11V9",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5V10.5",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5V11.5",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7V5",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8V6",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9V7",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10V8",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5V3",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5V3.5",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6V4",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7V5",
    stroke: "#7C7C7C",
    strokeWidth: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_6040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_6040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaoding);
export default __webpack_public_path__ + "static/media/diaoding.4cc8d36c9676ed2bff7440ed05a358ae.svg";
export { ForwardRef as ReactComponent };